// FDEIT PDP zoom (desktop only) - cursor-follow zoom
document.addEventListener("DOMContentLoaded", () => {
  if (window.matchMedia("(min-width: 990px)").matches === false) return;

  // Target only Dawn product gallery images (main media)
  const galleries = document.querySelectorAll('media-gallery[data-desktop-layout="thumbnail"]');
  if (!galleries.length) return;

  galleries.forEach((gallery) => {
    const mediaImages = gallery.querySelectorAll(".product__media img");
    mediaImages.forEach((img) => {
      const mediaWrap = img.closest(".product__media");
      if (!mediaWrap) return;

      mediaWrap.classList.add("fdeit-zoom");

      const setOrigin = (e) => {
        const rect = mediaWrap.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        mediaWrap.style.setProperty("--fdeit-origin", `${x}% ${y}%`);
      };

      mediaWrap.addEventListener("mouseenter", (e) => {
        setOrigin(e);
        mediaWrap.classList.add("is-zooming");
      });

      mediaWrap.addEventListener("mousemove", setOrigin);

      mediaWrap.addEventListener("mouseleave", () => {
        mediaWrap.classList.remove("is-zooming");
        mediaWrap.style.removeProperty("--fdeit-origin");
      });
    });
  });
});